export const professors = {
    over: " 외 ",
    people: "명",
}
